export default __webpack_public_path__ + "static/media/coopercitrus.be2cb84e.png";